import styled from "styled-components";

export const FooterWrapper = styled.footer`
  background-color: #f2f2f2;
`;

export const FooterContainer = styled.div`
  margin: 0 auto;
  padding: 1rem 2rem;

  @media (min-width: 1024px) {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  @media (min-width: 640px) {
    padding-top: 4rem;
    padding-bottom: 42px;
  }
`;

export const FooterInner = styled.div`
  @media (min-width: 1024px) {
    padding: 2rem;
  }
`;

export const FooterMain = styled.div`
  display: flex;
  row-gap: 1.5rem;
  flex-direction: column;

  .FooterGcIcon {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 34px;
    margin-bottom: 35px;
  }

  @media (min-width: 1024px) {
    justify-content: space-between;
    flex-direction: row;
  }
`;

export const FooterBottom = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;

  @media (min-width: 640px) {
    margin-top: 42px;
  }
`;

export const FooterCopyright = styled.p`
  font-weight: 600;
  font-size: 16px;

  /* Desktop version - hidden on mobile */
  &.footer-copyright-desktop {
    display: block;

    @media (max-width: 1023px) {
      display: none;
    }
  }

  /* Mobile version - hidden on desktop, shown at bottom on mobile */
  &.footer-copyright-mobile {
    display: none;
    text-align: left;
    margin-top: 1.5rem;
    order: 2;
    font-size: 12px;

    @media (max-width: 1023px) {
      display: block;
    }
  }
`;

export const FooterNav = styled.div`
  display: flex;
  column-gap: 75px;

  & > div {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.32px;
  }

  h3 {
    font-weight: 800;
    font-size: 16px;
    margin-bottom: 2rem;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    margin-top: 16px;
  }

  li:first-child {
    margin-top: 0;
  }

  li a {
    display: inline-block;
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-decoration: none;
    color: rgb(95, 99, 104);
  }

  li a:hover {
    color: rgb(32, 33, 36);
  }

  @media (min-width: 1024px) {
    flex-basis: 396px;
  }

  @media (min-width: 640px) {
    column-gap: 129px;
  }
`;

export const FooterInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  row-gap: 1.5rem;

  .footer-puct-wrapper {
    order: 2;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    align-items: center;

    .footer-puct-wrapper {
      order: initial;
    }
  }
`;

export const FooterPuct = styled.span`
  order: 9999;
  width: fit-content;
  border-radius: 0.5rem;
  background-color: rgba(95, 99, 104, 0.1);
  padding: 0.375rem 0.75rem;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.32px;

  @media (min-width: 1024px) {
    order: -9999;
  }
`;

export const FooterContactInfo = styled.div`
  display: flex;
  column-gap: 57px;
  row-gap: 1.5rem;
  flex-direction: column;

  a {
    display: inline-flex;
    align-items: center;
    column-gap: 1rem;
    text-decoration: none;
    color: rgb(32, 33, 36);
  }

  a span {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.32px;
    font-weight: 600;
  }

  @media (min-width: 1024px) {
    align-items: center;
  }

  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

export const FooterLinks = styled.div`
  display: flex;
  margin-top: 54px;
  align-items: flex-start;
  row-gap: 1.5rem;
  border-top: 1px solid rgba(95, 99, 104, 0.1);
  padding-top: 1.5rem;
  flex-direction: column;
  order: 3;

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
    order: initial;
  }

  & > div:first-child {
    display: inline-flex;
    align-items: flex-end;
    column-gap: 0.875rem;

    a {
      border-radius: 50%;
      background-color: #fff;
      padding: 0.75rem;
      font-size: 0;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transition: box-shadow 0.3s ease;

      &:hover {
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      }
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;
    }
  }

  & > div:last-child {
    display: inline-flex;
    column-gap: 30px;
    color: rgb(95, 99, 104);
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.36px;

    a {
      color: inherit;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      transition: text-shadow 0.3s ease;
      text-underline-offset: 2px;

      &:hover {
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
      }
    }
  }
`;
